import request from '../utils/request';

export interface Conversation {
  id: number;
  user_id: number;
  title: string;
  create_time?: string;
  update_time?: string;
}

export interface CreateConversationParams {
  title?: string;
  firstMessage?: string;
}

export interface ApiResponse<T> {
  code: number;
  message: string;
  data: T;
}

/**
 * 创建对话
 */
export const createConversation = async (
  params?: CreateConversationParams
): Promise<ApiResponse<{ conversation: Conversation }>> => {
  return request.post('/conversations', params || {});
};

/**
 * 获取用户的所有对话
 */
export const getConversations = async (limit = 50, offset = 0): Promise<ApiResponse<{ conversations: Conversation[] }>> => {
  return request.get('/conversations', { params: { limit, offset } });
};

/**
 * 获取单个对话
 */
export const getConversationById = async (id: number): Promise<ApiResponse<{ conversation: Conversation }>> => {
  return request.get(`/conversations/${id}`);
};

/**
 * 更新对话
 */
export const updateConversation = async (
  id: number,
  params: { title: string }
): Promise<ApiResponse<{ conversation: Conversation }>> => {
  return request.put(`/conversations/${id}`, params);
};

/**
 * 删除对话
 */
export const deleteConversation = async (id: number): Promise<ApiResponse<void>> => {
  return request.delete(`/conversations/${id}`);
};

/**
 * 批量删除对话
 */
export const batchDeleteConversations = async (ids: number[]): Promise<ApiResponse<{ affectedRows: number }>> => {
  return request.delete('/conversations/batch', { data: { ids } });
};
